import { CrewAccordion } from 'components/elements/crewAccordion/crewAccordion'
import { FC, memo, useCallback } from 'react'
import { FavoriteProjectList } from './components/favoriteProjectList/favoriteProjectList'
import {
  FavoriteProjectMenuActionType,
  FavoriteProjectContextMenu,
} from './components/favoriteProjectContextMenu/favoriteProjectContextMenu'
import { useTranslation } from '@crew/modules/i18n'
import { useUpdateFavoriteDisplayOrderTypeMutation } from '@crew/apis/favorite/favoriteApis'
import { FavoriteDisplayOrderType } from '@crew/enums/domain'
import { useShowApiErrors } from 'hooks/useShowApiErrors'
import { useLoadUserSettings } from '@crew/states'

// お気に入りプロジェクトを表示するパネル
export const FavoriteProjectPanel: FC = memo((props) => {
  const { t } = useTranslation()
  const [showApiErrors] = useShowApiErrors()

  // お気に入り表示順設定変更API
  const [updateFavoriteDisplayOrderTypeMutation] =
    useUpdateFavoriteDisplayOrderTypeMutation()

  // ユーザー設定再取得
  const [loadUserSettings] = useLoadUserSettings()

  const handleMenuItemClick = useCallback(
    async (action: FavoriteProjectMenuActionType) => {
      try {
        // お気に入り表示順種類設定変更APIを実行
        await updateFavoriteDisplayOrderTypeMutation({
          displayOrderType:
            action === FavoriteProjectMenuActionType.nameOrder
              ? FavoriteDisplayOrderType.Name
              : FavoriteDisplayOrderType.Activity,
        }).unwrap()

        // Sliceにも反映
        loadUserSettings()
      } catch (error) {
        showApiErrors(error)
      }
    },
    [loadUserSettings, showApiErrors, updateFavoriteDisplayOrderTypeMutation]
  )

  const renderToolIcon = useCallback(
    () => <FavoriteProjectContextMenu onMenuItemClick={handleMenuItemClick} />,
    [handleMenuItemClick]
  )

  return (
    <CrewAccordion
      id="favorite-project-panel"
      title={t('label.project')}
      content={<FavoriteProjectList />}
      renderToolIcon={renderToolIcon}
    />
  )
})
